(function($){
class w4d_arhiva_narudzbi {
	constructor() {
		this.$body = $('body');
        this.woocommerce = $('.woo-wrapper');
        this.cart = $('.cart');
		this.selectors = {
			button: '.arhiviraj-narudzbu, .de-arhiviraj-narudzbu',
			row: '.orders-table__row',
		};
		this.theEvents();
		
	}

	theEvents() {
		jQuery(document).on('click', this.selectors.button, (e) => {
			this.uradiArhiviranje(jQuery(e.currentTarget));
		});
	}

	uradiArhiviranje($btn) {
       
		const orderId = $btn.data('order-number');
		let action = $btn.hasClass('de-arhiviraj-narudzbu') ? 'de_arhiviraj_narudzbu' : 'arhiviraj_narudzbu';


		jQuery.ajax({
			url: w4d_frontend_ajax.ajax_url,
			type: 'POST',
			data: {
				action: action,
				order_id: orderId
			},
			beforeSend: () => {
				this.cart.addClass('cart--loading');
                
			},
			success: (response) => {
				if (response.success) {
					$btn.closest(this.selectors.row).fadeOut();
					let message=response.data.message;   
                    W4D_FrontendHelper.showNotice('success', message);
				} else {
					let message=response.data.message.replace(/<[^>]*>?/gm, '');   
                    W4D_FrontendHelper.showNotice('error', message);
				}
			},
			complete: () => {
				setTimeout(() => {
					this.cart.removeClass('cart--loading');					
				}, 150);
			}
		});
	}
}
$(document).ready(() => {
    new w4d_arhiva_narudzbi();
});
})(jQuery);
